import { useSelector } from 'react-redux';

import { selectIsReplay } from '@/modules/tryIt/redux/selectors';

import { ContextPanelReplay } from './Replay/ContextPanelReplay';
import { ContextPanelTest } from './Test/ContextPanelTest';

/** Mode router for the Context tab — test-mode editor vs. read-only replay view. */
export const ContextPanel = () => {
  const isReplay = useSelector(selectIsReplay);
  return isReplay ? <ContextPanelReplay /> : <ContextPanelTest />;
};
